/**
 * Constantes et configurations pour les graphiques
 */

// Couleurs des graphiques
export const CHART_COLORS = {
  en_production: '#5076FF',
  hors_production: '#E4EAFF',
  in_prod: '#5076FF',
  out_prod: '#E4EAFF',
  pr: [
    '#FF8534',
    '#4719FF',
    '#FFC122',
    '#5076FF',
    '#DBD2FF',
    '#04BB79',
    '#FFF1CC',
    '#FFDE89',
    '#E3A400',
    '#B98501',
    '#B3A0FF',
    '#7350FF',
    '#2600BE',
    '#FFD2B4',
    '#FFA76C',
    '#F76300',
    '#B94A00',
    '#CFFFEE',
    '#94FFD8',
    '#30E7A5',
    '#007B4F',
    '#E4EAFF',
    '#99AFFF',
    '#0036FB',
    '#00229C',
    '#C9FFFF',
    '#8CFFFF',
    '#15FCFC',
    '#00CCCC',
    '#008D8D',
    '#FF8F7F',
    '#FC3115',
  ],
  log: [
    '#FFF1CC',
    '#FFDE89',
    '#FFC122',
    '#E3A400',
    '#B98501',
    '#DBD2FF',
    '#B3A0FF',
    '#7350FF',
    '#4719FF',
    '#2600BE',
    '#FFD2B4',
    '#FFA76C',
    '#FF8534',
    '#F76300',
    '#B94A00',
    '#CFFFEE',
    '#94FFD8',
    '#30E7A5',
    '#04BB79',
    '#007B4F',
    '#E4EAFF',
    '#99AFFF',
    '#5076FF',
    '#0036FB',
    '#00229C',
    '#C9FFFF',
    '#8CFFFF',
    '#15FCFC',
    '#00CCCC',
    '#008D8D',
    '#FF8F7F',
    '#FC3115',
  ],
}

// Labels des graphiques
export const CHART_LABELS = {
  en_production: 'En production',
  hors_production: 'Hors production',
  in_prod: 'En production',
  out_prod: 'Hors production',
}

// Configuration par défaut des graphiques
export const DEFAULT_CHART_OPTIONS = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
      labels: {
        boxWidth: 15,
      },
    },
    title: {
      display: false,
    },
  },
}

// Configuration pour les graphiques radiaux (Doughnut, Radar)
export const RADIAL_CHART_OPTIONS = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      labels: {
        boxWidth: 15,
      },
    },
    title: {
      display: false,
    },
  },
}

// Configuration pour les graphiques de logs (Bar)
export const LOG_CHART_OPTIONS = {
  aspectRatio: 3.8,
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      labels: {
        boxWidth: 15,
      },
    },
    title: {
      display: false,
    },
  },
}

// Configuration des échelles radiales par défaut
export const getRadialScaleConfig = (theme, showGrid = false, showTicks = false, showPointLabels = false) => ({
  axis: 'r',
  type: 'radialLinear',
  display: true,
  animate: true,
  position: 'chartArea',
  angleLines: {
    display: showGrid,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0,
    color: theme === 'dark' ? '#313131' : '#f4f4f4',
  },
  grid: {
    circular: false,
    display: showGrid,
    lineWidth: 1,
    drawBorder: true,
    drawOnChartArea: true,
    drawTicks: true,
    tickLength: 8,
    offset: false,
    borderDash: [],
    borderDashOffset: 0,
    borderWidth: 1,
    color: theme === 'dark' ? '#313131' : '#f4f4f4',
    borderColor: theme === 'dark' ? '#313131' : '#f4f4f4',
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: true,
    color: theme === 'dark' ? '#fff' : '#666',
    minRotation: 0,
    maxRotation: 50,
    mirror: false,
    textStrokeWidth: 0,
    textStrokeColor: '',
    padding: 3,
    display: showTicks,
    autoSkip: true,
    autoSkipPadding: 3,
    labelOffset: 0,
    minor: {},
    major: {},
    align: 'center',
    crossAlign: 'near',
    backdropColor: showTicks ? '#fff0' : 'rgba(255, 255, 255, 0.75)',
    backdropPadding: 2,
  },
  pointLabels: {
    backdropPadding: 2,
    display: showPointLabels,
    font: {
      size: showPointLabels ? 8 : 10,
    },
    padding: showPointLabels ? 2 : 5,
    centerPointLabels: false,
    color: theme === 'dark' ? '#fff' : '#666',
  },
  offset: false,
  reverse: false,
  beginAtZero: false,
  bounds: 'ticks',
  grace: 0,
  title: {
    display: false,
    text: '',
    padding: {
      top: 4,
      bottom: 4,
    },
    color: theme === 'dark' ? '#fff' : '#666',
  },
  id: 'r',
})

// Configuration des échelles temporelles
export const getTimeScaleConfig = (theme, stacked = true) => ({
  type: 'time',
  time: {
    unit: 'day',
  },
  stacked: stacked,
  ticks: {
    beginAtZero: true,
    maxRotation: 0,
    minRotation: 0,
    color: theme === 'dark' ? '#fff' : '#666',
  },
  grid: {
    color: theme === 'dark' ? '#313131' : '#f4f4f4',
  },
})

// Configuration des échelles linéaires
export const getLinearScaleConfig = (theme, stacked = true) => ({
  stacked: stacked,
  ticks: {
    color: theme === 'dark' ? '#fff' : '#666',
  },
  grid: {
    color: theme === 'dark' ? '#313131' : '#f4f4f4',
  },
})

// Configuration des options de graphique de logs
export const getLogChartOptions = (theme, stacked = true) => ({
  ...LOG_CHART_OPTIONS,
  plugins: {
    ...LOG_CHART_OPTIONS.plugins,
    legend: {
      ...LOG_CHART_OPTIONS.plugins.legend,
      labels: {
        ...LOG_CHART_OPTIONS.plugins.legend.labels,
        color: theme === 'dark' ? 'white' : '',
      },
    },
  },
  interaction: {
    intersect: false,
  },
  scales: {
    x: getTimeScaleConfig(theme, stacked),
    y: getLinearScaleConfig(theme, stacked),
  },
})

// Styles CSS
export const CHART_STYLES = {
  height300: 'height300',
}
